<base-support-modal [title]="title" [btnOkClass]="'btn-success'" [btnOkLabel]="'Применить'" (onOk)="ok()" >
	<div [formGroup]="form">
		<div class="form-group">
			<label class="control-label">Тариф</label>
			<select [(ngModel)]="tariffId" class="form-control" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateVariants()">
				<option *ngFor="let tariff of tariffs" value="{{tariff._id}}">{{i18nTariffs[tariff._id].name}}</option>
			</select>
		</div>
	
		<div class="form-group">
			<label class="control-label">Вариант тарифа</label>
			<ng-container *ngIf="periodType==1">
				<select [(ngModel)]="variantName" class="form-control" [ngModelOptions]="{standalone: true}">
					<ng-container *ngIf="tariffs.length > 0">
						<option *ngFor="let variant of tariffsVariants" value="{{variant.name}}">
							{{i18nTariffs[tariffId].variants[variant.name]}}
					</option>
					</ng-container>
				</select>
			</ng-container>
			<ng-container *ngIf="periodType==2">
				<datepicker formControlName="customDateTo" [(ngModel)]="customDateTo" [disabledPast]="true"></datepicker>
			</ng-container>
			<ng-container *ngIf="periodType==3">
				<input type="number" [ngModelOptions]="{standalone: true}" min="1" [(ngModel)]="customDaysCount" class="form-control">
			</ng-container>
		</div>
	
		<div class="form-group">
			<div class="form-check">
				<input class="form-check-input" type="radio" [ngModelOptions]="{standalone: true}" name="periodType" id="periodType1" [(ngModel)]="periodType" [value]="1">
				<label class="form-check-label" for="periodType1">Предустановленные</label>
			</div>
			<div class="form-check">
				<input class="form-check-input" type="radio" [ngModelOptions]="{standalone: true}" name="periodType" id="periodType2" [(ngModel)]="periodType" [value]="2">
				<label class="form-check-label" for="periodType2">Произвольная дата окончания</label>
			</div>
			<div class="form-check">
				<input class="form-check-input" type="radio" [ngModelOptions]="{standalone: true}" name="periodType" id="periodType3" [(ngModel)]="periodType" [value]="3" [disabled]="!notFirstPayment">
				<label class="form-check-label" for="periodType3">Произвольное количество дней</label>
			</div>
		</div>
	
		<div class="form-group">
			<label class="control-label">Номер транзакции/счёта</label>
			<div class="input-group">
				<input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="invoiceNumber" class="form-control">
				<div class="input-group-append">
					<button class="btn btn-outline-secondary" (click)="getInvoiceInfo()" type="button"><i aria-hidden="true" class="fa fa-search"></i></button>
				</div>
			</div>
			
		</div>
	
		<div class="form-group" *ngIf="paymentType!=999">
			<label class="control-label">Сумма</label>
			<input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="amount" class="form-control" placeholder="0000.00">
		</div>
	
		<div class="form-group">
			<div class="form-check">
				<input class="form-check-input" type="radio" [ngModelOptions]="{standalone: true}" name="paymentType" id="paymentType99" [(ngModel)]="paymentType" [value]="99">
				<label class="form-check-label" for="paymentType99">Оплачено безналом</label>
			</div>
	
			<div class="form-check">
				<input class="form-check-input" type="radio" [ngModelOptions]="{standalone: true}" name="paymentType" id="paymentType999" [(ngModel)]="paymentType" [value]="999">
				<label class="form-check-label" for="paymentType999">Даётся бесплатно</label>
			</div>
	
			<ng-container *ngIf="!notFirstPayment">
				<div class="form-check">
					<input class="form-check-input" type="radio" [ngModelOptions]="{standalone: true}" name="paymentType" id="paymentType9999" [(ngModel)]="paymentType" [value]="9999">
					<label class="form-check-label" for="paymentType9999">Номер заказа Divly</label>
				</div>
				
				<input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="paymentId" class="form-control" [disabled]="paymentType!=9999">
			</ng-container>
		</div>
	</div>
</base-support-modal>
